import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { gcpThrottleEnabled, pageSize } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(
    AdditionalFields,
    {
      title: t("common.fields.advanced_options"),
      visible: isAdvancedOptionsVisible,
      onToggle: handleToggle
    },
    /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "gcpThrottleEnabled", defaultChecked: gcpThrottleEnabled == null ? void 0 : gcpThrottleEnabled.value, onChange }),
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "pageSize",
        type: "number",
        value: pageSize.value || pageSize.defaultValue,
        min: "1000",
        onChange,
        required: true,
        help: t("gcp.fields.page_size_help"),
        label: t("gcp.fields.page_size")
      }
    )
  );
};
export default FormAdvancedOptions;
